/* unplugin-vue-components disabled */import script from "./SideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBar.vue?vue&type=script&lang=ts&setup=true"

import "./SideBar.vue?vue&type=style&index=0&id=30c46f86&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ZhongGuan\\Project\\zhong-guan-lh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30c46f86"]])

export default __exports__